// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Modal-module--wrapper--1KxRc","open":"Modal-module--open--NkFeZ","modal":"Modal-module--modal--FqeFw","title":"Modal-module--title--1M23p"};